module.exports = __webpack_public_path__ + "img/ar-icon.b4d33eac.png";